import { gql } from "@apollo/client";

export const getScheduleReportByJobIdQuery = gql`
query($jobId: String!, $scheduleAssignedTaskId: String, $checkCallId: String){
  getScheduleReportByJobId(jobId: $jobId, scheduleAssignedTaskId: $scheduleAssignedTaskId, checkCallId:$checkCallId) {
    response
    message
  }
}
`;


export const getScheduleReportBySiteandTemplateIdQuery = gql `
query($templateId: String!, $siteId: String!){
  getScheduleReportBySiteandTemplateId(templateId: $templateId, siteId: $siteId) {
    message
    response
  }
}
`;